<div class="partner-home-container">
  <!-- Dashboard Section -->
  <div class="dashboard-container">
    <!-- My Dashboard Card (Left Side) -->
    <div class="my-dashboard-card" (click)="navigateToDashboard()">
      <div class="dashboard-content">
        <div class="dashboard-text">
          <h2 class="dashboard-title">{{"homepage.dashboard.title" | translate }}</h2>
          <p class="dashboard-description">
            {{"homepage.dashboard.description" | translate }}
          </p>
          <button class="review-button" (click)="navigateToDashboard()">{{ 'homepage.dashboard.review' | translate
            }}</button>
        </div>

        <div class="chart-container">
          <div class="bar-chart">
            <div class="bar bar-1"></div>
            <div class="bar bar-2"></div>
            <div class="bar bar-3"></div>
            <div class="bar bar-4"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column Cards -->
    <div class="right-column">
      @if(accessible(RoleConstants.VIEW_PARTNER_COMM_PAGE)) {
      <!-- Communications Card -->
      <div class="image-card communications-card" (click)="navigateToCommunications()">
        <img src="assets/images/cors_communication.jpg" class="card-background"
          alt="{{ 'homepage.dashboard.communications' | translate }}">
        <div class="card-overlay"></div>
        <h3 class="large-card-title">
          @for (word of getCommunicationsWords(); track $index) {
          <span>{{ word }}</span>
          }
        </h3>
      </div>
      }

      @if(accessible(RoleConstants.VIEW_PARTNER_PROMO_PAGE)) {
      <div class="image-card educational-card" (click)="navigateToPromotions()">
        <img src="assets/images/educational_materials.jpg" class="card-background"
          alt="{{ 'homepage.dashboard.educationalMaterial' | translate }}">
        <div class="card-overlay"></div>
        <h3 class="large-card-title">
          @for (word of getEducationalMaterialWords(); track $index) {
          <span>{{ word }}</span>
          }
        </h3>
      </div>
      }
    </div>
  </div>

  <!-- Manage Accounts Section -->
  <div class="accounts-overview-card">
    <div class="accounts-overview-content">
      <div class="accounts-overview-text">
        <h2 class="accounts-overview-title">{{ 'homepage.dashboard.accountsHeader' | translate }}</h2>
        <p class="accounts-overview-description">{{ 'homepage.accounts.overview' | translate }}</p>
      </div>
      <div class="accounts-overview-actions">
        @if(accessible(RoleConstants.VIEW_PARTNER_ACCOUNTS)) {
        <!-- Find an Account Card -->
        <div class="account-action-card" (click)="navigateToAccounts()">
          <div class="account-action-card-content">
            <div class="account-action-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path
                  d="M22 38C30.8366 38 38 30.8366 38 22C38 13.1634 30.8366 6 22 6C13.1634 6 6 13.1634 6 22C6 30.8366 13.1634 38 22 38Z"
                  stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M42 42L33.3 33.3" stroke="black" stroke-width="3" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <p class="account-action-text">{{ 'homepage.accounts.findAccount' | translate }}</p>
          </div>
          <div class="account-action-accent">
            <svg xmlns="http://www.w3.org/2000/svg" width="204" height="204" viewBox="0 0 204 204" fill="none"
              class="accent-circle-primary">
              <circle cx="102" cy="102" r="102" fill="#D6EBFF" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"
              class="accent-circle-secondary">
              <circle cx="96" cy="96" r="96" fill="#B8DCFF" />
            </svg>
            <button class="account-action-plus-button" aria-label="Find an Account">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 8V16" stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8 12H16" stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        }

        @if(accessible(RoleConstants.VIEW_PARTNER_SALES_OFFICES)) {
        <!-- Find or Add Sales Office Card -->
        <div class="account-action-card" (click)="navigateToSalesOffice()">
          <div class="account-action-card-content">
            <div class="account-action-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path
                  d="M40 6H8C5.79086 6 4 7.79086 4 10V30C4 32.2091 5.79086 34 8 34H40C42.2091 34 44 32.2091 44 30V10C44 7.79086 42.2091 6 40 6Z"
                  stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16 42H32" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24 34V42" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <p class="account-action-text">{{ 'homepage.accounts.findAddSalesOffice' | translate }}</p>
          </div>
          <div class="account-action-accent">
            <svg xmlns="http://www.w3.org/2000/svg" width="204" height="204" viewBox="0 0 204 204" fill="none"
              class="accent-circle-primary">
              <circle cx="102" cy="102" r="102" fill="#D6EBFF" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"
              class="accent-circle-secondary">
              <circle cx="96" cy="96" r="96" fill="#B8DCFF" />
            </svg>
            <button class="account-action-plus-button" aria-label="Find or Add Sales Office">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 8V16" stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8 12H16" stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        }

        @if(accessible(RoleConstants.VIEW_PARTNER_USERS)) {
        <!-- Find or Add a User Card -->
        <div class="account-action-card" (click)="navigateToUsers()">
          <div class="account-action-card-content">
            <div class="account-action-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <g clip-path="url(#clip0_3419_8336)">
                  <path
                    d="M31.8926 41.8591V37.8725C31.8926 35.7579 31.0526 33.7299 29.5573 32.2346C28.0621 30.7394 26.0341 29.8994 23.9195 29.8994H9.96644C7.85183 29.8994 5.82383 30.7394 4.32857 32.2346C2.83331 33.7299 1.99329 35.7579 1.99329 37.8725V41.8591"
                    stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M16.943 21.9262C21.3465 21.9262 24.9162 18.3565 24.9162 13.953C24.9162 9.54956 21.3465 5.97986 16.943 5.97986C12.5396 5.97986 8.96985 9.54956 8.96985 13.953C8.96985 18.3565 12.5396 21.9262 16.943 21.9262Z"
                    stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M39.8657 15.9463V27.906" stroke="black" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M45.8456 21.9261H33.8859" stroke="black" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_3419_8336">
                    <rect width="47.8389" height="47.8389" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="account-action-text">{{ 'homepage.accounts.findAddUser' | translate }}</p>
          </div>
          <div class="account-action-accent">
            <svg xmlns="http://www.w3.org/2000/svg" width="204" height="204" viewBox="0 0 204 204" fill="none"
              class="accent-circle-primary">
              <circle cx="102" cy="102" r="102" fill="#D6EBFF" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"
              class="accent-circle-secondary">
              <circle cx="96" cy="96" r="96" fill="#B8DCFF" />
            </svg>
            <button class="account-action-plus-button" aria-label="Find or Add a User">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 8V16" stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8 12H16" stroke="#005AB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Bottom Cards Section -->
  <div class="bottom-cards-section">
    <!-- My Programs Card -->
    @if(hasProgramModels()) {
    <div class="bottom-card" (click)="navigateToPrograms()">
      <div class="bottom-card-content">
        <div class="bottom-card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_3419_8242)">
              <path d="M9.99999 1.66669L1.66666 5.83335L9.99999 10L18.3333 5.83335L9.99999 1.66669Z" stroke="#667180"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M1.66666 14.1667L9.99999 18.3334L18.3333 14.1667" stroke="#667180" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M1.66666 10L9.99999 14.1667L18.3333 10" stroke="#667180" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_3419_8242">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <p class="bottom-card-text">{{ 'homepage.partner.headers.myPrograms' | translate }}</p>
      </div>
    </div>
    }

    <!-- Training Catalog Card -->
    <div class="bottom-card" (click)="navigateToTrainingCatalog()">
      <div class="bottom-card-content">
        <div class="bottom-card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M3.33331 16.25C3.33331 15.6975 3.55281 15.1676 3.94351 14.7769C4.33421 14.3862 4.86411 14.1667 5.41665 14.1667H16.6666"
              stroke="#667180" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M5.41665 1.66669H16.6666V18.3334H5.41665C4.86411 18.3334 4.33421 18.1139 3.94351 17.7232C3.55281 17.3325 3.33331 16.8026 3.33331 16.25V3.75002C3.33331 3.19749 3.55281 2.66758 3.94351 2.27688C4.33421 1.88618 4.86411 1.66669 5.41665 1.66669Z"
              stroke="#667180" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p class="bottom-card-text">{{ 'homepage.partner.headers.trainingCatalog' | translate }}</p>
      </div>
    </div>

    <!-- CISM Card -->
    <div class="bottom-card" (click)="navigateToCISM()">
      <div class="bottom-card-content">
        <div class="bottom-card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M11.6667 1.66669H5.00004C4.55801 1.66669 4.13409 1.84228 3.82153 2.15484C3.50897 2.4674 3.33337 2.89133 3.33337 3.33335V16.6667C3.33337 17.1087 3.50897 17.5326 3.82153 17.8452C4.13409 18.1578 4.55801 18.3334 5.00004 18.3334H15C15.4421 18.3334 15.866 18.1578 16.1786 17.8452C16.4911 17.5326 16.6667 17.1087 16.6667 16.6667V6.66669L11.6667 1.66669Z"
              stroke="#667180" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.6666 1.66669V6.66669H16.6666" stroke="#667180" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M13.3333 10.8333H6.66663" stroke="#667180" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M13.3333 14.1667H6.66663" stroke="#667180" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M8.33329 7.5H7.49996H6.66663" stroke="#667180" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <p class="bottom-card-text">{{ 'homepage.partner.headers.cism' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Marketing Headline / Event Panel Section -->
  <div class="marketing-headline-section">
    <div class="helpful-resources-section">
      <div class="helpful-resources-grid">
        @if (partialFeatureResource.length) {
        @for (resource of partialFeatureResource.slice(0, 4); track resource.nodeId; let i = $index) {
        <div class="helpful-resource-card" (click)="openPromotionalContent(resource)">
          <img class="card-icon" [src]="resource.image" alt="resource icon" />
          <h3 class="card-title">
            {{ resource.text && resource.text.indexOf(':') > -1 ? resource.text.split(':')[0] : resource.text }}
            <span class="sub-title" *ngIf="resource.text && resource.text.indexOf(':') > -1">{{
              resource.text.split(':').slice(1).join(':').trim() }}</span>
          </h3>
        </div>
        }
      } @else {
        <div class="helpful-resource-card"></div>
        <div class="helpful-resource-card"></div>
        <div class="helpful-resource-card"></div>
        <div class="helpful-resource-card"></div>
      }
    </div>
  </div>
</div>
</div>
